import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import { EvmBlockDetailInfo } from '~/api/repository'
import { blockDetailKey } from '~/api/service/query-keys.const'

export const useFetchBlockDetail = (blockNumber: Ref<string>, isEnable?: Ref<boolean>) => {
  return useQuery<ViewBlockDetailInfo>({
    queryKey: [ ...blockDetailKey, blockNumber ],
    queryFn: () => {
      return explorerApi.blockController.getBlockDetail({ 
        requestBody: {
          blockNumber: blockNumber.value 
        }
       }).then((res) => {
        return blockDetailDto(res as EvmBlockDetailInfo)
      })
    },
    enabled: isEnable,
  })
}

export type ViewBlockDetailInfo = EvmBlockDetailInfo & {
  unixTimeStamp: string;
  gasUsed: string;
  gasLimit: string;
  totalDifficulty: string;
  size: string;
  baseFeePerGas: string;
  baseFeePerGasGwei: string;
  burntFees: string;
  blockReward: string;
}

const blockDetailDto = (block: EvmBlockDetailInfo): ViewBlockDetailInfo => {
  return {
    ...block,
    unixTimeStamp: secondsToDate(block.UT),
    gasUsed: setComma(block.GU),
    gasLimit: setComma(block.GL),
    totalDifficulty: setComma(block.TDF),
    size: setComma(block.SI),
    baseFeePerGas: setComma(block.BFPG),
    baseFeePerGasGwei: setComma(block.BFPGG),
    burntFees: setComma(block.BF),
    blockReward: setComma(block.BR),
  }
}